import React from "react";

//components
import { IconLibrary } from "../../../interfaces/icon/IconLibrary";
import Icon from "../icons/Icon";



const DragButton = ({dragRef, className}: {dragRef: any, className: string}) => {   
    
    return (
        <button 
            ref={dragRef} 
            className={`drag-button ${className ?? ""}`} 
            aria-hidden="true" 
            tabIndex={-1}
        >
            <Icon iconName={IconLibrary.DRAG} color="#999EA5" sizeInPx="12"/>
        </button>
    );
}

export default DragButton